export default "__VITE_ASSET__XvA4z3zL__"